'use strict';

module.exports = require('./Icon');